// Preact
import {h} from 'preact'
// query string
import qs from 'qs'
// React Router
import {
    HashRouter as Router
  } from 'react-router-dom'
// Split at search
import splitAtSearch from './splitAtSearch'
// Checkout
import Checkout from './Checkout'

const App = ({csrfKey, csrfVal}) => {
  // Get parameters from URL
  let cart_token, order_id, shop, gateway_response_gateway_id, paypal_order_id, ba_token, cancel
  const parsedSearch = qs.parse(location.search, {ignoreQueryPrefix: true})

  if(Object.keys(parsedSearch).length > 0) {
    cart_token = parsedSearch.cart_token
    order_id = parsedSearch.checkout_order_id ? parsedSearch.checkout_order_id : parsedSearch.order_id
    paypal_order_id = (parsedSearch.checkout_order_id && parsedSearch.order_id) ? parsedSearch.order_id : parsedSearch.token
    ba_token = parsedSearch.ba_token ? parsedSearch.ba_token : null
    shop = parsedSearch.shop
    gateway_response_gateway_id = parsedSearch.gateway_response_gateway_id
    cancel = parsedSearch.cancel
  } else {
    const parsedHash = qs.parse(splitAtSearch(location.hash, '?')[1], {ignoreQueryPrefix: true})
    
    if(Object.keys(parsedHash).length > 0) {
      cart_token = parsedHash.cart_token
      order_id = parsedHash.order_id
      shop = parsedHash.shop
      gateway_response_gateway_id = parsedHash.gateway_response_gateway_id
    }
  }

  return (
    <Router>
      <Checkout headers={{
          'x-csrf-key': csrfKey,
          'x-csrf-val': csrfVal,
          'cache-control': 'no-store, no-cache, must-revalidate',
          'X-Requested-With': 'XmlHttpRequest',
          'X-Content-Type-Options': 'nosniff',
          'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
          'Keep-Alive': 'timeout=5, max=96'
        }}
        cart_token={cart_token}
        order_id={order_id}
        paypal_order_id={paypal_order_id}
        ba_token={ba_token}
        shop={shop}
        gateway_response_gateway_id={gateway_response_gateway_id}
        cancel={cancel}
      />
    </Router>
  )
}

export default App


// WEBPACK FOOTER //
// ./client/resources/js/checkout/App.js